{
  "title": "Notifications",
  "mark_all": "Mark all read",
  "empty": "No notifications",
  "loading": "Loading…",
  "view_all": "View all",
  "page_subtitle": "All your notifications in one place",
  "load_more": "Load more",
  "loading_more": "Loading…",
  "empty_page_title": "No notifications yet",
  "empty_page_subtitle": "When you're assigned tasks or someone comments, they'll show up here.",
  "time": {
    "now": "now",
    "minutes_ago": "{n} min ago",
    "hours_ago": "{n} h ago",
    "days_ago": "{n} d ago"
  }
}
